/**
 * Labels for mobile view of the securities search table.
 * @type {{attach: Drupal.behaviors.securitiesSearchTableLabels.attach}}
 */
const $ = window.jQuery;

export default {
  attach: function (context, settings) {
    const securitiesSearchTableLabels_once = once('securities-search-table-labels-once', '.view-securities-search', context);

    $(securitiesSearchTableLabels_once).each(function () {
      let $tableHeadLabels = $(this).find('.view-content table thead tr th');
      let labelStyles = '';

      $tableHeadLabels.each(function(index) {
        let $labelText = $(this).text();

        labelStyles = labelStyles + '.view-securities-search .view-content table tbody tr td:nth-child(' + (index + 1) + ')::before { content: "' + $labelText + ':"; } '
      });

      $('head').append('<style>' + labelStyles + '</style>');
    });
  },
}
